import mapMarker from './map-marker.png';

document.addEventListener('DOMContentLoaded', () => {
  const googleMaps = document.querySelectorAll('.wp-block-mitery-blocks-google-maps');

  const initMap = async (googleMap) => {
    if (typeof google === 'object') {
      const latitude = googleMap.getAttribute('data-latitude');
      const longitude = googleMap.getAttribute('data-longitude');
      const zoom = googleMap.getAttribute('data-zoom');
      const address = googleMap.getAttribute('data-address');
      const mapId = googleMap.getAttribute('data-map-id');
      
      const { Map } = await google.maps.importLibrary('maps');
      const map = new Map(googleMap, {
        center: { lat: Number(latitude), lng: Number(longitude) },
        zoom: Number(zoom),
        mapId: mapId,
      });
      const {AdvancedMarkerElement} = await google.maps.importLibrary('marker');
      const markerIcon = document.createElement("img");
  
      markerIcon.src = mapMarker;
  
      const markerOptions = {
        position: { lat: Number(latitude), lng: Number(longitude) },
        map: map,
        title: address,
        content: markerIcon,
      };
      new AdvancedMarkerElement(markerOptions);
    }
  }

  googleMaps.forEach((googleMap) => {
    initMap(googleMap);
  });
});
